import React from 'react';
import { Box, Link, Image } from '@chakra-ui/react';
export default function Footer() {
  return (
    <Box textAlign={'center'} mb={5}>
      <Link fontSize={'13px'} style={{ textDecoration: 'underline' }} href='https://popular-pagamenti.web.app'>
        <Image w={'130px'} m='auto' src='/images/logo-white.png' alt='logo-popular' />
        Powered by Popular
      </Link>
    </Box>
  );
}
